// @ts-nocheck
import React, { useState } from "react";

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import {
    Container,
    PageHeader,
    Content,
    Text,
    InfoProcuracao,
    Button
} from "./styles";

import Header from "../../components/Header";
import { ModalCertidao } from "../../components/Modal";

import Frame from "../../assets/header/frame-procuracao.png";
import FrameMobile from "../../assets/header/frame-procuracao-mobile.png";

import { useRequirement } from '../../hooks/requirement';
import { FormularioNativo } from '../Procuracao/FormularioNativo';

export function EmissaoCertidao() {
    const { requirement } = useRequirement();

    const [certidaoModal, setCertidaoModal] = useState(false);

    return (
        <>
            <Header />
            <Container>
                <PageHeader>
                    <Content>
                        <Text>
                            <p className="title">{requirement?.type}</p>
                            <h2>
                                Formulário de dados da certidão para o pedido de
                                <span> {requirement?.applicant}</span>
                            </h2>
                            <p className="description">
                                Preencha esses dados para dar andamento à emissão de certidão do seu pedido
                            </p>
                        </Text>
                        <img className="frameDesktop" src={Frame} alt="Frame"/>
                        <img className="frameMobile" src={FrameMobile} alt="Frame"/>
                    </Content>
                </PageHeader>
                <InfoProcuracao style={{ alignItems: 'center' }}>
                    <h3>Alguma dúvida para achar os dados?</h3>
                    <p style={{ textAlign: 'center' }}>Alguns modelos de certidão têm um padrão de posicionamento. Assim, fica mais fácil de saber qual 
                        número é do livro, da folha e do termo da certidão.</p>
                    <Button type="button" onClick={() => setCertidaoModal(true)}>
                        Ver onde achar os dados
                    </Button>
                </InfoProcuracao>
                {requirement?.process_id && requirement?.reference_id ? (
                    <FormularioNativo processId={requirement.process_id} referencia={requirement.reference_id} />
                ) : (
                    <InfoProcuracao>
                        <h3>Não achamos o documento</h3>
                        <p>Volte para meus pedidos e clique de novo no botão de emissão do documento.</p>
                        <a href="/">
                            <ChevronLeftIcon />
                            Voltar para meus pedidos
                        </a>
                    </InfoProcuracao>
                )}
            </Container>
            <ModalCertidao openModal={certidaoModal} closeModal={() => setCertidaoModal(false)} />
        </>
    );
}